import { useState } from "react";
import intl from "react-intl-universal";
import { TbBuildingBank } from "react-icons/tb";
import { useBaasCapabilities } from "../../../../../Hooks/useBaasCapabilities";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";
import { BaasAccountTransferModal } from "./BaasAccountTransferModal";

/**
 * Opens the internal-transfer modal targeting instance shells
 * (PROGRAM_RESERVE by default). Hidden when the caller cannot transfer.
 */
export const BaasFundShellsButton = ({
  destinationAccountId = null,
  destinationRole = "program_reserve",
  variant = "button",
  className = "btn-primary !text-xs",
  disabled = false,
}) => {
  const { can } = useBaasCapabilities();
  const [open, setOpen] = useState(false);
  const allowed = can("accounts.transfer");

  if (!allowed) return null;

  const label = intl.get("baas.accounts.transfer.fundShellsConfirm");

  return (
    <>
      {variant === "shortcut" ? (
        <ShortcutCard
          icon={TbBuildingBank}
          label={label}
          disabled={disabled}
          onClick={() => setOpen(true)}
        />
      ) : (
        <button
          type="button"
          className={className}
          disabled={disabled}
          onClick={() => setOpen(true)}
        >
          {label}
        </button>
      )}
      <BaasAccountTransferModal
        open={open}
        onClose={() => setOpen(false)}
        fundShells
        destinationAccountId={destinationAccountId}
        destinationRole={destinationRole}
      />
    </>
  );
};
